import React, { useEffect, useState } from 'react';
import { Box, Container, List, ListItem, ListItemText, Typography } from '@mui/material';

import UIUX from '../assets/Images/services/uiuxlogo.png';
import CustomerStories from './CustomerStories';
import { workCaseStudy } from '../interface/WorkCaseStudy';
import workJson from "../Work.json";
import Footer from '../components/Footer';
import { serviceWorkFilter } from '../common-functions/serviceWorkFilter';
import { CardData, TabData } from '../interface/TabData';
import ServiceTabbingSection from '../sub-sections/ServiceCommonComponent/ServiceTabbingSection';
import ServiceCardSection from '../sub-sections/ServiceCommonComponent/ServiceCardSection';
import CaseStudyLetsGetStarted from '../sub-sections/CaseStudy/CaseStudyLetsGetStarted';
import useMetaTags from '../common-functions/useMetaTags';

const UIUXDesignSection: React.FC = () => {
    useMetaTags(
        "UI/UX Design Services | Web & Mobile App Interface Experts",
        "Elevate your digital presence with our expert UI/UX design services. We create engaging, user-friendly interfaces for web and mobile apps—focused on usability, responsiveness, and cross-platform consistency.",
        "UI/UX design services, web app UI design, mobile UX experts, responsive design solutions, wireframing and prototyping, cross-platform design, user interface design company, design for usability, app design agency"
      );
    const tabData: TabData[] = [
        {
          heading: (<>Wireframing &<br /> Prototyping</>),
          imgSrc: `
            <img class="animation-img-class animation-delay300 disnone img-responsive wow fadeInDown animated fadeinScroll"
            src="/assets/Images/uiux/wireframing.png" alt="wireframing-prototyping" data-wow-duration="1500ms" data-wow-delay="300ms"
            style="display: block;">`,
          content: (
            <>
              <p>We offer wireframing and prototyping services to map out your application structure, ensuring early-stage clarity and aligning visual flow before development begins.</p>
              <p>This service helps visualize layouts, navigation, and user flows—streamlining the design process and minimizing revisions during development.</p>
              <p>Take a peek at our past work <a href="/work" onClick={() => selectedTechnology()} className="underlineancor">right here</a>.</p>
            </>
          ),
        },
        {
          heading: (<>Web & Mobile App<br /> Design</>),
          imgSrc: `
            <img class="animation-img-class animation-delay300 disnone img-responsive wow fadeInDown animated fadeinScroll"
            src="/assets/Images/uiux/app-design.png" alt="web-mobile-app-design" data-wow-duration="1500ms" data-wow-delay="300ms"
            style="display: block;">`,
          content: (
            <>
              <p>Our team delivers custom web and mobile app UI/UX designs tailored to business needs, enhancing usability and visual impact across all devices and platforms.</p>
              <p>We craft engaging interfaces that match your user needs, offering pixel-perfect designs ready for development on both mobile and web platforms.</p>
              <p>See what we’ve designed so far by <a href="/work" onClick={() => selectedTechnology()} className="underlineancor">visiting this page</a>.</p>
            </>
          ),
        },
        {
          heading: (<>Responsive<br /> Design</>),
          imgSrc: `
            <img class="animation-img-class animation-delay300 disnone img-responsive wow fadeInDown animated fadeinScroll"
            src="/assets/Images/uiux/responsive.png" alt="responsive-design" data-wow-duration="1500ms" data-wow-delay="300ms"
            style="display: block;">`,
          content: (
            <>
              <p>With responsive design, we make sure your product adapts smoothly to all screen sizes—providing a seamless experience from desktops to mobile devices.</p>
              <p>This service guarantees flexibility and usability, ensuring your project works perfectly on phones, tablets, and widescreens without content loss.</p>
              <p>You can explore more examples <a href="/work" onClick={() => selectedTechnology()} className="underlineancor">on this link</a>.</p>
            </>
          ),
        },
        {
          heading: (<>Cross-Platform<br /> Compatibility</>),
          imgSrc: `
            <img class="animation-img-class animation-delay300 disnone img-responsive wow fadeInDown animated fadeinScroll"
            src="/assets/Images/uiux/cross-platform.png" alt="cross-platform-design" data-wow-duration="1500ms" data-wow-delay="300ms"
            style="display: block;">`,
          content: (
            <>
              <p>We develop UI/UX solutions that work seamlessly across platforms, optimizing design consistency for web, Android, and iOS environments.</p>
              <p>This ensures your interface looks and performs equally well across operating systems, improving user retention and reducing development costs.</p>
              <p>Click <a href="/work" onClick={() => selectedTechnology()} className="underlineancor">to check our showcases</a>.</p>
            </>
          ),
        }
      ];      
      

    const cardsData: CardData[] = [
        {
          heading: 'SaaS Platforms & B2B Tools',
          items: [
            'User-friendly SaaS dashboard design and development',
            'Scalable UI for business automation platforms',
            'Seamless UX for B2B product interfaces',
            'Custom UI/UX for admin and CRM systems',
            'Intuitive user journey mapping for SaaS tools'
          ]
        },
        {
          heading: 'Logistics & Transportation',
          items: [
            'Real-time tracking UI for delivery platforms',
            'Fleet management dashboard with clean UX',
            'Transport booking app design with smart flow',
            'Warehouse UI design for logistics operations',
            'Simplified route planning interface for drivers'
          ]
        },
        {
          heading: 'Real Estate & Property Tech',
          items: [
            'Interactive property listing and filtering UX',
            'Real estate mobile app interface design',
            'Smart rental application and booking screens',
            'Agent dashboard and lead management system',
            'Seamless UI for virtual property viewing'
          ]
        },
        {
          heading: 'Media & Entertainment',
          items: [
            'Streaming platform design for video content apps',
            'Music and podcast player user interface design',
            'News platform layout with storytelling UX',
            'Ticket booking experience for event platforms',
            'Creator dashboard UI for media portals'
          ]
        }
      ];
      

    const selectedTechnology = () => {
        sessionStorage.setItem("Selected-Vertical", 'All');
        sessionStorage.setItem("Selected-Technology", 'All');
    }
    const [works, setWorks] = useState<workCaseStudy[]>([]);
    useEffect(() => {
        const keywords = ['ui', 'ux','web','mobile', 'cloud'];
        const additionalKeywords = ['ai', 'artificialintelligence', 'machinelearning', 'automation', 'deeplearning', 'datascience', 'technology', 'microsoft'];
        const results = serviceWorkFilter(workJson.workCaseStudy, keywords, additionalKeywords);
        setWorks(results);
    }, []);
    return (
        <>
            <Box sx={{ padding: 4, textAlign: 'center' }} className="contentbox whitebox ">
                <Container className="innerpagecontainer contentpage">
                    <Typography variant="h2" gutterBottom className='contentwidth to_build'>
                    Elevate Your Digital Presence with Our End-to-End UI/UX Services </Typography>

                    <Typography variant="body1" sx={{ marginBottom: 2 }} className='contentwidth'>
                    We craft intuitive, high-performance UI/UX designs that enhance user engagement, streamline workflows, and bring your digital products to life—tailored for startups, enterprises, and everything in between </Typography>

                    <div className='servicesLogo'>
                        <ul>
                            <li><span>
                                <img
                                    src={UIUX}
                                    alt="sharepoint-consulting"
                                    style={{height:"60px"}}
                                /></span></li>

                           

                        </ul>
                    </div>


                </Container>
            </Box>

            <Box className="outerbox powerbitab" sx={{ bgcolor: "#f2c811" }}  >
                <ServiceTabbingSection tabData={tabData} />
            </Box>
            <Box sx={{ padding: 4 }} className="contentbox whitebox contentpage"  >
                <Container className="innerpagecontainer contentpage" >
                    <ServiceCardSection cardsData={cardsData} verticalTitle='Industries We Transform with Tailored UI/UX Solutions for Real-World Impact' />
                </Container>
            </Box>

            {/* <ServiceCarousel category="azureAWSCloud" /> */}
            {works.length > 0 &&
                <CustomerStories pageName='service' workList={works} />
            }
            <CaseStudyLetsGetStarted projectName='Azure AWS Service' />
            {works.length > 0 ?
                <Footer hasWorkItem={false} /> : <Footer hasWorkItem={true} />
            }
        </>
    );
};

export default UIUXDesignSection;